import { gatewayClient, createService } from './connectors/httpClient';

const httpClient = gatewayClient('/creatives');

const designsService = createService(httpClient, (client) => ({
    createBlankDesign(data, collectionId) {
        let path = `/blank`;

        if (collectionId) {
            path += `?collectionId=${collectionId}`;
        }

        return client.put<{ id: number; name: string }>(path, data);
    },

    createFromXML(data, collectionId) {
        return client.post(`/from-xml${collectionId ? `?collectionId=${collectionId}` : ''}`, data);
    },

    duplicateCreatives(ids, collectionId) {
        return client.put('/duplicate', { ids, collectionId });
    },

    createVideoCreative(data) {
        return client.put<{ id: number }>('/convert', data);
    },
}));

export default designsService;
